import { TUserProfileInfo } from 'types/state';
import { M8UserProfile, M8UserProfileUpdate } from 'services/production/types';
import { normalizeOrgStaffCount } from 'services/production/utils/normalizeOrgStaffCount';

export const normalizeClientProfileInfo = (clientInfo: TUserProfileInfo) => ({
  toM8UserProfile: (): Partial<M8UserProfile> => ({
    firstName: clientInfo.firstName,
    lastName: clientInfo.lastName,
    middleName: clientInfo.middleName,
    position: clientInfo.position,
    organization: clientInfo.company,
    companySize: clientInfo.orgStaffCount
      ? normalizeOrgStaffCount(clientInfo.orgStaffCount).toCompanySize()
      : 'UNDEFINED',
    phone: clientInfo.phone,
  }),
  toM8UserProfileUpdate: (): M8UserProfileUpdate => {
    if (clientInfo.location === null) {
      throw new TypeError();
    }

    return {
      firstName: clientInfo.firstName,
      lastName: clientInfo.lastName,
      middleName: clientInfo.middleName,
      position: clientInfo.position,
      organization: clientInfo.company,
      companySize: clientInfo.orgStaffCount
        ? normalizeOrgStaffCount(clientInfo.orgStaffCount).toCompanySize()
        : 'UNDEFINED',
      phone: clientInfo.phone,
      resident: clientInfo.resident,
      country: clientInfo.location,
    };
  },
});
